//DEVELOPMENT

// export const BASE_URL = "https://apidev.sociohood.com/api";

//PROD SERVER
 export const BASE_URL = "https://apiprodi3.sociohood.com/api";

//LOCAL SERVER
// export const BASE_URL = "http://localhost:8000/api";
